module.exports = __webpack_public_path__ + "static/media/file-pdf.0ec3ffbc.svg";